import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tmargin: 0;\n\tborder: 0;\n\tborder-top: 2px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from '../theme-provider';
export var Divider = styled.hr.withConfig({
  displayName: "Divider",
  componentId: "sc-1c4dpfj"
})(_templateObject(), function (props) {
  return props.theme.separatorColor;
});
Divider.displayName = 'Divider';